<template>
  <a-card>
    <div class="ant-descriptions-title">
      Company
    </div>
    <a-skeleton :loading="loadingList" :paragraph="{ rows: 6 }">
      <a-form-model
        labelAlign="left"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="Name / Tên công ty">
          <a-input v-model="form.name" placeholder="Write name" />
        </a-form-model-item>
        <a-form-model-item label="Short name / Tên viết tắt">
          <a-input v-model="form.shortName" placeholder="Write short name" />
        </a-form-model-item>
        <a-form-model-item label="Logo">
          <a-input v-model="form.logoUrl" placeholder="Write link url" />
          <div style="max-width: 150px; margin-top: 20px;" v-if="form.logoUrl">
            <img alt="previewImage" style="width: 100%;" :src="form.logoUrl" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="Phone number / Điện thoại">
          <a-input v-model="form.phone" placeholder="Write phone number" />
        </a-form-model-item>
        <a-form-model-item label="Adress / Địa chỉ">
          <a-textarea
            v-model="form.address"
            placeholder="Write address"
            :auto-size="{ minRows: 3 }"
          />
        </a-form-model-item>
        <a-form-model-item label="Slogan / Khẩu hiệu">
          <a-textarea
            v-model="form.slogan"
            placeholder="Write slogan"
            :auto-size="{ minRows: 5 }"
          />
        </a-form-model-item>
        <a-form-model-item
          :wrapper-col="{ span: 20, offset: 4 }"
          style="text-align: right;"
        >
          <a-button style="margin-right: 10px;" @click="resetForm">
            Cancel
          </a-button>
          <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
            Update
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-skeleton>
  </a-card>
</template>
<script>
import query from "../constants/query";
export default {
  props: {},
  data() {
    return {
      form: {},
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      loadingList: false,
      loadingBtn: false,
      appConfigOrganization: {},
    };
  },
  methods: {
    onGetAppConfigOrganization() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAppConfigOrganization,
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getAppConfigOrganization) {
            this.appConfigOrganization = { ...data.getAppConfigOrganization };
            this.form = { ...data.getAppConfigOrganization };
          }
          this.loadingList = false;
        })
        .catch((error) => {
          this.loadingList = false;
          console.log("Không lấy được danh sách", error);
        });
    },
    onCreateAppConfigOrganization() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.createAppConfigOrganization,
          variables: {
            logoUrl: this.form.logoUrl,
            shortName: this.form.shortName,
            name: this.form.name,
            slogan: this.form.slogan,
            address: this.form.address,
            phone: this.form.phone,
          },
        })
        .then(({ data }) => {
          if (data?.createAppConfigOrganization) {
            this.refreshAfterSubmitted(data.createAppConfigOrganization);
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Updated Error!", error);
        });
    },
    onUpdateAppConfigOrganization() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateAppConfigOrganization,
          variables: {
            id: this.form.id,
            logoUrl: this.form.logoUrl,
            shortName: this.form.shortName,
            name: this.form.name,
            slogan: this.form.slogan,
            address: this.form.address,
            phone: this.form.phone,
          },
        })
        .then(({ data }) => {
          if (data?.updateAppConfigOrganization) {
            this.refreshAfterSubmitted(data.updateAppConfigOrganization);
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Không tạo được được thông tin!", error);
        });
    },
    onSubmit() {
      if (this.form?.id) {
        this.onUpdateAppConfigOrganization();
      } else {
        this.onCreateAppConfigOrganization();
      }
    },
    resetForm() {
      this.form = { ...this.appConfigOrganization };
    },
    refreshAfterSubmitted(appConfigOrganization) {
      this.appConfigOrganization = {
        ...this.appConfigOrganization,
        ...appConfigOrganization,
      };
      this.form = { ...this.appConfigOrganization, ...appConfigOrganization };
    },
  },
  created() {
    this.onGetAppConfigOrganization();
  },
};
</script>
<style lang="css" scoped></style>
